import { Box } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import React from "react";

const Advertisement: React.FC<{onClose: ()=>void; className?: string;}> = ({onClose, className=""}) => {

    return (
        <Box
            sx={{
                position: "fixed",
                height: "100vh",
                width: "100%",
                top: "0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: "10000",
                background: "rgba(0,0,0,0.4)"
            }}
        >
            <Box 
            className={`popupBox ${className}`}
            >
                <Box
                onClick={onClose}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    top: "10px",
                    right: "5px",
                    background: "#ffffff"
                }}
                >
                    <CloseIcon />
                </Box>
                <img style={{ border: "none" }} src="/assets/images/home/popupimage2627_23102026.jpg" width="100%" height="100%" alt="banner" />
            </Box>
        </Box>
    )
}
export default Advertisement;